import axios from 'axios';
import BaseAPI from './base/base-api';

class EmailAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'emails';
}

export default new EmailAPI();